<template>
  <div class="company-contain">
    <div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px;">
      <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
        <div class="loading-img"></div>
      </div>
    </div>

    <!-- main -->
    <div class="search-company-box">   
      <div class="pledge-box1-top">
        <label class="el-checkbox mar" v-if="hasPerExpess"> 
          <span class="el-checkbox-input" :class="{'is-checked': showPerExpress}" @click.stop.prevent="openPerExpress($event)">
            <span class="el-checkbox-inner" @click.stop.prevent="openPerExpress($event)"></span> 
            <input type="checkbox" name="type" class="el-checkbox-original"> 
          </span> 
          <span class="el-checkbox-label">业绩快报详情</span> 
        </label>

        <!-- <div class="Quarterly-Report"> 
          <div class="head-title">2018-03-31<span class="close-bot"></span></div>
          <ul class="menu-lanmu" style="display:none;">  
            <li><a href="#">2017-03-31</a></li>
            <li><a href="#">2016-03-31</a></li> 
            <li><a href="#">2015-03-31</a></li>
            <li><a href="#">2014-03-31</a></li>   
          </ul>
        </div> -->
      </div>

      <div class="pledge-box1">
        <div class="pledge-box1">  
          <div class="Single-list-main" v-if="performanceNoticeLists.length > 0"> 
            <template v-for="(index, h) in performanceNoticeLists" track-by="$index"> 
              <ul class="Single-list-box">
                <li><p class="date">公告日期</p> <p class="time">{{ h.publishdate }}</p></li>
                <li>
                  <p class="date">定期报告</p> 
                  <p class="time">{{ h.bglx }} ({{ parseInt(h.period_start.split('-')[1])}} ~ {{parseInt(h.period_end.split('-')[1])}} 月)</p>
                </li>
                <li>
                  <p class="date">摘要</p> 
                  <p class="time">
                    <template v-if="h.net_profit_reporting_period_income_lower && h.net_profit_reporting_period_income_upper && h.change_ratio_lower && h.change_ratio_upper">
                      净利润{{ h.net_profit_reporting_period_income_lower | toWan | money }}万元
                      至{{ h.net_profit_reporting_period_income_upper | toWan | money}}万元,
                      <template v-if="h.year_on_year_change == '增长'">
                        增长幅度为{{ h.change_ratio_lower | formatFloat }}%
                        至{{ h.change_ratio_upper | formatFloat}}%
                      </template>
                      <template v-if="h.year_on_year_change == '下降'">
                        下降幅度为{{ h.change_ratio_upper | formatFloat }}%
                        至{{ h.change_ratio_lower | formatFloat}}%
                      </template>
                    </template>

                    <template v-if="h.net_profit_reporting_period_income_lower && h.net_profit_reporting_period_income_upper && !h.change_ratio_lower && !h.change_ratio_upper">
                      净利润{{ h.net_profit_reporting_period_income_lower | toWan | money }}万元至{{ h.net_profit_reporting_period_income_upper | toWan | money}}万元
                    </template>

                    <template v-if="!h.net_profit_reporting_period_income_lower && !h.net_profit_reporting_period_income_upper && h.change_ratio_lower && h.change_ratio_upper">
                      <template v-if="h.year_on_year_change == '增长'">
                        增长幅度为{{ h.change_ratio_lower | formatFloat }}%
                        至{{ h.change_ratio_upper | formatFloat}}%
                      </template>
                      <template v-if="h.year_on_year_change == '下降'">
                        下降幅度为{{ h.change_ratio_upper | formatFloat }}%
                        至{{ h.change_ratio_lower | formatFloat}}%
                      </template>
                    </template>

                    <template v-if="!h.net_profit_reporting_period_income_lower && !h.net_profit_reporting_period_income_upper && !h.change_ratio_lower && !h.change_ratio_upper">
                      <span v-if="h.operating_profit_reporting_period">
                        本期营业收入： {{ h.total_operating_income_reporting_period | toWan | money }}(万元)、
                      </span>
                      <span v-if="h.net_profit_reporting_period">
                        本期净利润： {{ h.net_profit_reporting_period | toWan | money }}(万元)
                      </span>
                    </template>
                  </p>
                </li>
                <li>
                  <p class="date">净利润预计变动幅度(%)</p> 
                  <p class="time">
                    <template v-if="h.typ == 'notice'">
                      <span class="c-rise" v-if="h.year_on_year_change == '增长'">
                        {{h.change_ratio_upper | formatFloat | nullValue }}
                      </span>
                      <span class="c-fall" v-if="h.year_on_year_change == '下降'">
                        {{h.change_ratio_lower | formatFloat | nullValue }}
                      </span>
                      <span v-if="!h.year_on_year_change">-</span>
                    </template>

                    <template v-if="h.typ == 'express'">
                      <span class="c-rise" v-if="isShow(h.net_profit_change_ratio) == 1">
                        {{ h.net_profit_change_ratio | formatFloat | nullValue }}
                      </span>
                      <span class="c-fall" v-if="isShow(h.net_profit_change_ratio) == 2">
                        {{ h.net_profit_change_ratio | formatFloat | nullValue }}
                      </span>
                      <span v-if="isShow(h.net_profit_change_ratio) == 3">-</span>
                    </template>
                  </p>
                </li> 
                <li>
                  <p class="date">净利润实际变动幅度(%)</p>
                  <p class="time c-fall">
                    <span v-if="h.jllfdreal!=''" :class="{'c-rise': h.jllfdreal>=0, 'c-fall': h.jllfdreal<0}">{{ h.jllfdreal }}</span>
                    <span v-else>-</span>
                  </p>
                </li>   
                <li>
                  <p class="date">本期净利润(元)</p> 
                  <p class="time c-rise">
                    <span :class="{'c-rise': h.retainedprofit>=0, 'c-fall': h.retainedprofit<0}">{{ h.retainedprofit | formatSnjlr }}</span>
                  </p>
                </li>
                <li>
                  <p class="date">上年同期净利润(元)</p> 
                  <p class="time">
                    <template v-if="h.typ == 'notice'">
                      <span class="c-rise" v-if="isShow(h.net_profit_last_year_income) == 1">{{ h.net_profit_last_year_income | formatSnjlr }}
                      </span>
                      <span class="c-fall" v-if="isShow(h.net_profit_last_year_income) == 2">
                        {{ h.net_profit_last_year_income | formatSnjlr }}
                      </span>
                      <span  v-if="isShow(h.net_profit_last_year_income) == 3">-</span>
                    </template>

                    <template v-if="h.typ == 'express'">
                      <span class="c-rise" v-if="isShow(h.net_profit_last_year) == 1">
                        {{ h.net_profit_last_year | formatSnjlr }}
                      </span>
                      <span class="c-fall" v-if="isShow(h.net_profit_last_year) == 2">
                        {{ h.net_profit_last_year | formatSnjlr }}
                      </span>
                      <span v-if="isShow(h.net_profit_last_year) == 3">
                        -
                      </span>
                    </template>
                  </p>
                </li>   
              </ul> 
              
              <div class="Express-box" v-if="h.typ == 'express' && showPerExpress">   
                <ul class="Express-news">
                  <li class="active">营业收入</li>  
                  <li>
                    <p class="date">营业收入（万元）</p>
                    <p class="time">
                      {{ h.total_operating_income_reporting_period | toWan | money }}
                      <span v-if="h.total_operating_income_reporting_period && h.total_operating_income_reporting_period!=''">(万元)</span>
                    </p>
                  </li> 
                  <li>
                    <p class="date">同比增长（%）</p>
                    <p class="time">
                      {{h.total_operating_income_last_year | toWan | money}}
                      <span v-if="h.total_operating_income_last_year && h.total_operating_income_last_year!=''">(万元)</span>
                    </p>
                  </li> 
                  <li>
                    <p class="date">净利润（万元）</p>
                    <p class="time">
                      <span class="c-rise" v-if="isShow(h.total_operating_income_change_ratio) == 1">{{h.total_operating_income_change_ratio}}</span>
                      <span class="c-fall" v-if="isShow(h.total_operating_income_change_ratio) == 2">{{h.total_operating_income_change_ratio}}</span>
                      <span v-if="isShow() == ">-</span>
                    </p>
                  </li>
                  
                  <li class="active">净利润</li>  
                  <li><p class="date">去年同期（万元）</p>
                    <p class="time">
                      {{h.net_profit_reporting_period | toWan | money}}
                      <span v-if="h.net_profit_reporting_period && h.net_profit_reporting_period!=''">(万元)</span>
                    </p>
                  </li>
                  <li>
                    <p class="date">同比增长（%）</p>
                    <p class="time c-fall">
                      {{h.net_profit_last_year | toWan | money}}
                      <span v-if="h.net_profit_last_year && h.net_profit_last_year!=''">(万元)</span>
                    </p>
                  </li>   
                </ul> 
                <ul class="Express-news">
                  <li>
                    <p class="date">每股收益（元）</p>
                    <p class="time">{{ h.basic_earnings_per_share_reporting_period | nullValue }}</p>
                  </li> 
                  <li>
                    <p class="date">每股净资产（元）</p>
                    <p class="time">{{ h.net_assets_per_share_reporting_period | nullValue }}</p>
                  </li> 
                  <li>
                    <p class="date">净资产收益率（%）</p>
                    <p class="time">{{ h.weighted_average_return_on_net_assets_reporting_period | nullValue }}</p>
                  </li>   
                </ul> 
              </div> 
            </template>
          </div>  

          <div class="Single-list-main" v-if="performanceNoticeLists.length == 0"> 
            <div class="Block-trade-no">暂无数据</div>
          </div>   
        </div>
      </div>
    </div>

  </div>

  <!--微信绑定弹框-->
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" v-show="tipGoBind">
    <div class="binding-content">
      <a class="binding-logo"></a>
      <div class="binding-text">
        立即绑定IBDATA账号<br/>成为金融分析高手
      </div>
      <div class="binding-bot">
        <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
        <a class="binding-btn" @click="goBindPage">立即绑定</a>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade in" v-show="tipGoBind"></div>
  <!-- / 微信绑定弹框-->
</template>

<script>
  import { alert, apiUrl, downloadURL } from '../../helper'
  import $ from 'jquery'
  import userMix from '../../common/userMix'
  import searchMix from '../../common/searchMix'
  import comSearchMix from '../../common/comSearchMix'
  import companyMix from '../../common/companyMix'
  import echartMix from '../../common/echartMix'
  import echarts from 'echarts'
  import wxshareMix from '../../common/wxshareMix'


  export default {
    name: 'FinanceView',
    mixins: [userMix, searchMix, comSearchMix, companyMix, echartMix, wxshareMix],
    data () {
      return {
        hasPerExpess: false,
        showPerExpress: false,
        performanceNoticeLists: [],
        perSort: {
          type: '',
          ksrq: 1,
          jsrq: 1,
          jllfd: 1,
          bnjll: 1,
          snjll: 1,
          ggrq: 1,
        },
        sort: '',
        desc: '',
      }
    },
    route: {
      data({to}) {

        if (!this.currentuser) {
          this.wxcode = this.getQueryString('code')  // 获取微信登录code
          if (this.wxcode) {
            this.wxlogin(this.wxcode)
          } else {
            this.getProfile(to.query.share)
          }
        }

        if (this.currentuser) { 
          this.queryParam = to.query;
          this.companycode = to.query.companycode;
          this.stype = to.query.stype;

          // 微信签名 分享
          let title = decodeURIComponent(to.query.desc);
          let desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
          document.title = title;
          this.getwxsign()    // 微信签名
          this.shareCompany(title, desc);

          this.setSelectedTab();
          this.getPerformanceNotice();
        }

      }
    },
    methods: {
      /**
       * 业绩预告表排序
       */
      sortPerformanceTable: function(type) {
        this.sort = type;
        // this.perSortDes = 2;

        // 净利润变动幅度
        if (type == 'jllfd') {

          if (this.desc != 2) {

            this.desc = 2;
            this.performanceNoticeLists.sort((a, b) => {
              return parseFloat(b.jlrbdfd) - parseFloat(a.jlrbdfd);
            });

          } else {

            this.desc = 1;
            this.performanceNoticeLists.sort((a, b) => {
              return parseFloat(a.jlrbdfd) - parseFloat(b.jlrbdfd);
            });

          }

        } else if (type == 'bnjll') {  // 本期净利润

          if (this.desc != 1) {

            this.desc = 1;
            this.performanceNoticeLists.sort((a, b) => {
              return parseFloat(b.bntqjlr) - parseFloat(a.bntqjlr);
            });

          } else {

            this.desc = 2;
            this.performanceNoticeLists.sort((a, b) => {
              return parseFloat(a.bntqjlr) - parseFloat(b.bntqjlr);
            });

          }
          console.log(this.performanceNoticeLists);

        } else if (type == 'snjll') {  // 上年净利润

          if (this.desc != 1) {

            this.desc = 1;
            this.performanceNoticeLists.sort((a, b) => {
              return parseFloat(b.sntqjlr) - parseFloat(a.sntqjlr);
            });

          } else {

            this.desc = 2;
            this.performanceNoticeLists.sort((a, b) => {
              return parseFloat(a.sntqjlr) - parseFloat(b.sntqjlr);
            });

          }

        } else if (type == 'ggrq') {     // 公告日期

          if (this.desc != 1) {

            this.desc = 1;
            this.performanceNoticeLists.sort((a, b) => {
              return Date.parse(b.publishdate) - Date.parse(a.publishdate);
            });

          } else {

            this.desc = 2;
            this.performanceNoticeLists.sort((a, b) => {
              return Date.parse(a.publishdate) - Date.parse(b.publishdate);
            });

          }
        }
      },
      noticeType: function(sdate, edate) {
        if (!sdate || !edate) return;

        if (edate.indexOf('-') != -1) {
          let year = edate.split('-')[0] + '年';
          let month = parseInt(edate.split('-')[1]);

          if (month >= 3 && month < 6) {
            return year + '一季报';
          } else if (month >= 6 && month < 9) {
            return year + '半年报';
          } else if (month == 12) {
            return year + '年报';
          } else if (month >= 9 && month <12){
            return year + '三季报';
          }
        }
      },
      getPerformanceNotice: function() {
        this.hasPerExpess = false;

        let query = {};
        query.companycode = this.companycode;
        query.uid = parseInt(this.queryParam.uid)
        query.ruid = parseInt(this.queryParam.ruid)
        query.share = this.queryParam.share
        query.plat = this.queryParam.plat
        query.sid = this.queryParam.sid

        this.loading = true;
        $.ajax({
          url: apiUrl('/V1.0.0/company/performancenotice'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {

          this.loading = false;
          if (response.status === 0) {
            let list = response.data;
            for (let item of list) {
              if (item.typ == 'express') {
                this.hasPerExpess = true;

                // 净利润变动幅度
                item.jlrbdfd = 0;
                // 上年同期净利润
                item.sntqjlr = item.net_profit_last_year;
                // 本期净利润
                item.bntqjlr = item.retainedprofit;
                if (item.retainedprofit && item.net_profit_last_year) {
                    let jllfdreal = Math.round(((item.retainedprofit - item.net_profit_last_year) / item.net_profit_last_year) * 100, 2)
                    if ((item.retainedprofit-item.net_profit_last_year)<0 && jllfdreal > 0) {
                        item.jllfdreal = -jllfdreal
                    } else if ((item.retainedprofit-item.net_profit_last_year)>0 && jllfdreal < 0) {
                        item.jllfdreal = -jllfdreal
                    } else {
                        item.jllfdreal = jllfdreal
                    }
                } else {
                    item.jllfdreal = ''
                }
              } else if (item.typ == 'notice') {

                // 净利润变动幅度
                if (item.year_on_year_change == '增长') {
                  item.jlrbdfd = item.change_ratio_upper;
                } else if (item.year_on_year_change == '下降') {
                  item.jlrbdfd = item.change_ratio_lower;
                } else {
                  item.jlrbdfd = '-';
                }
                item.bntqjlr = item.retainedprofit;
                // 上年同期净利润
                item.sntqjlr = item.net_profit_last_year_income;
                if (item.retainedprofit && item.net_profit_last_year_income) {
                    let jllfdreal = Math.round(((item.retainedprofit - item.net_profit_last_year_income) / item.net_profit_last_year_income) * 100, 2)
                    if ((item.retainedprofit-item.net_profit_last_year_income)<0 && jllfdreal > 0) {
                        item.jllfdreal = -jllfdreal
                    } else if ((item.retainedprofit-item.net_profit_last_year_income)>0 && jllfdreal < 0) {
                        item.jllfdreal = -jllfdreal
                    } else {
                        item.jllfdreal = jllfdreal
                    }
                } else {
                    item.jllfdreal = ''
                }
              }

              //报告类型
              item.bglx = this.noticeType(item.period_start, item.period_end);
            }
            this.performanceNoticeLists = list;

            // this.divMinHeight('.search_bg');

            // 排序
            this.$nextTick(function() {
              this.sortPerformanceTable('ggrq');
            });
          } else {
            alert(response.description)
          }
        }).fail((response) => {
          this.loading = false;
          alert('请求失败')
        })
      },
      openPerExpress: function() {
        this.showPerExpress = this.showPerExpress ? false : true;
        console.log(this.showPerExpress);
      },
      isShow: function(num) {
        if (!num) { return 3; }

        num = parseFloat(num);
        if (num === 0) {
          return 3;
        } else if (num > 0) {
          return 1;
        } else if (num < 0) {
          return 2;
        }
      },
    }
  }
</script>

<style scoped>
  /* 加载 */
  .loading-box {
    top: 43% !important;
  }
  .loading-img {
    width: 35px;
    height: 35px;
    background-image: url('../../../static/images/loading2.gif');
    background-size: cover;
  }

  .Quarterly-Report .head-title {
    display: block;
  }

  /*.Single-list-main {
    width: 100%;
    box-shadow: none;
    padding: 0;
  }*/
  .gujia-chart-wrap {
    border: none !important;
  }
</style>


/** WEBPACK FOOTER **
 ** Performance.vue?3c9b2fea
 **/